module.exports = __webpack_public_path__ + "static/img/Appleroom.fe90961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/nets/Appleroom.png
// module id = fTyN
// module chunks = 0